import { Heading, Stack, Text } from 'braid-design-system';

import type { PublishedListing } from '#shared/types';

import { ListingCard } from './ListingCard';
import type { ListingGroup } from './filterListings';

interface ListingResultsProps {
  listings: PublishedListing[];
  groups?: ListingGroup[];
  loading: boolean;
  error: string | null;
}

const ListingStack = ({ listings }: { listings: PublishedListing[] }) => (
  <Stack space="medium">
    {listings.map((listing) => (
      <ListingCard key={listing.id} listing={listing} />
    ))}
  </Stack>
);

export const ListingResults = ({
  listings,
  groups,
  loading,
  error,
}: ListingResultsProps) => {
  if (loading) {
    return <Text>Loading listings…</Text>;
  }

  if (error) {
    return <Text tone="critical">{error}</Text>;
  }

  if (listings.length === 0) {
    return <Text>No listings match your filters yet.</Text>;
  }

  if (groups) {
    return (
      <Stack space="xlarge">
        {groups.map((group) => (
          <Stack key={group.heading} space="medium">
            <Heading level="3">{group.heading}</Heading>
            <ListingStack listings={group.listings} />
          </Stack>
        ))}
      </Stack>
    );
  }

  return <ListingStack listings={listings} />;
};
